export const ADD_COURSE_TO_CART_REQUEST = "ADD_COURSE_TO_CART_REQUEST";
export const ADD_COURSE_TO_CART_SUCCESS = "ADD_COURSE_TO_CART_SUCCESS";
export const ADD_COURSE_TO_CART_FAILURE = "ADD_COURSE_TO_CART_FAILURE";

export const GET_CART_DETAIL_REQUEST = "GET_CART_DETAIL_REQUEST";
export const GET_CART_DETAIL_SUCCESS = "GET_CART_DETAIL_SUCCESS";
export const GET_CART_DETAIL_FAILURE = "GET_CART_DETAIL_FAILURE";

export const DELETE_COURSE_FROM_CART_REQUEST =
  "DELETE_COURSE_FROM_CART_REQUEST";
export const DELETE_COURSE_FROM_CART_SUCCESS =
  "DELETE_COURSE_FROM_CART_SUCCESS";
export const DELETE_COURSE_FROM_CART_FAILURE =
  "DELETE_COURSE_FROM_CART_FAILURE";

export const RESET_ADD_COURSE_TO_CART = "RESET_ADD_COURSE_TO_CART";
export const RESET_REMOVE_COURSE_FROM_CART = "RESET_REMOVE_COURSE_FROM_CART";

export const GET_COURSES_FROM_CART_REQUEST = "GET_COURSES_FROM_CART_REQUEST";
export const GET_COURSES_FROM_CART_SUCCESS = "GET_COURSES_FROM_CART_SUCCESS";
export const GET_COURSES_FROM_CART_FAILURE = "GET_COURSES_FROM_CART_FAILURE";

export const RESET_ALL_ACTIONS = "RESET_ALL_ACTIONS";
